export const GetFactureUrl = () => `/ClubLink/GetFactorDetails`;
